<template lang="pug">
  p
    b-icon(icon='question-circle', type="is-primary", size="is-small")
    |
    |
    a(href="#", @click.prevent="showModal") お客様コードの確認方法
</template>

<script>
const ModalCustomerCode = {
  template: `
    <div class="modal-card" id="modal-customer-card">
      <header class="modal-card-head">
        <p class="modal-card-title">お客様コードの確認方法</p>
      </header>
      <section class="modal-card-body" id="modal-customer-card-body">
        <iframe id="codeframe" src=` + process.env.DNLICENSE_POPUP_URL + `/ccode/neo.html></iframe>
      </section>
      <footer class="modal-card-foot"><button class="button" type="button" @click="$parent.close">OK</button></footer>
    </div>
  `,
  data () {
    return {
      image: require('@/assets/images/customer-code.png')
    }
  }
}

export default {
  name: 'NoticeCustomerCode',
  methods: {
    showModal () {
      this.$modal.open({
        component: ModalCustomerCode,
        hasModalCard: true
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/apps/com/NoticeCustomerCode.vue